import styled from "styled-components";

function NotFound() {
  return (
    <Page>
      <Eyebrow>404</Eyebrow>
      <h1>This page isn’t on the menu.</h1>
      <p>
        The link may be broken, or the page may have moved. Let’s get you back
        to something tasty.
      </p>
      <HomeLink href="/">Go to Bite home</HomeLink>
    </Page>
  );
}

const Page = styled.main`
  width: min(100% - 40px, 640px);
  min-height: calc(100vh - 180px);
  min-height: calc(100svh - 180px);
  margin: 0 auto;
  padding: 72px 0;
  box-sizing: border-box;
  display: grid;
  align-content: center;
  justify-items: center;
  gap: 20px;
  text-align: center;
  color: #080808;

  h1 {
    margin: 0;
    font-family: "Recoleta", Georgia, serif;
    font-size: clamp(2.4rem, 7vw, 4rem);
    font-weight: 500;
    line-height: 1.02;
  }

  p {
    margin: 0;
    max-width: 440px;
    color: #687080;
    font-size: clamp(1.05rem, 1.6vw, 1.2rem);
    line-height: 1.4;
  }
`;

const Eyebrow = styled.span`
  color: #7d8490;
  font-size: 0.82rem;
  font-weight: 750;
  letter-spacing: 0.12em;
`;

const HomeLink = styled.a`
  min-height: 48px;
  margin-top: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 26px;
  border-radius: 999px;
  background: #050505;
  color: #ffffff;
  font-size: 1rem;
  font-weight: 650;
  text-decoration: none;

  &:hover {
    background: #242424;
  }

  &:focus-visible {
    outline: 3px solid #8ab4ff;
    outline-offset: 4px;
  }
`;

export default NotFound;
